import { PaymentSubType } from 'common/api/e-comm/payment-types';
import { IS_FLIPGIVE } from 'common/env';

/** FlipGive has no separate credit/debit card fields (FEC-2653 / FEC-2682). */
export const getCardPaymentLabel = (cardSubType?: PaymentSubType | string | null): string => {
    if (IS_FLIPGIVE) {
        return 'Card';
    }

    if (cardSubType) {
        return `${cardSubType} Card`;
    }

    return 'Credit Card';
};
